'use client';
import { PreviewVerificationSchema } from '@/common/types/api.interfaces';
import { calculateIncreasedDate } from '../../utils/calculateIncreasedDate';
import { UseMembershipDatesProps } from './MembershipTypeSection.types';
import dayjs from 'dayjs';

export const calculateDateWithBonus = ({
  voucherData,
  startDate,
}: {
  voucherData?: PreviewVerificationSchema | null;
  startDate: Date;
}) => {
  if (
    voucherData?.voucher_bonus_period &&
    voucherData?.voucher_bonus_period?.term_strategy !== 'END_OF_CURRENT_TERM'
  ) {
    return calculateIncreasedDate({
      amount: voucherData.voucher_bonus_period.term?.value ?? 0,
      unit: voucherData.voucher_bonus_period.term?.unit ?? '',
      startDate: startDate,
    });
  }

  return startDate;
};

export const useMembershipDates = (
  {
    isExtending,
    termData,
    customerExtensionEndDate,
    selectedStartDate,
  }: UseMembershipDatesProps
) => {

  const defaultStartDate = selectedStartDate ?? termData?.defaultContractStartDate;

  const defaultContractStartDate = new Date(
    defaultStartDate ?? ''
  );
  // TODO: update preuse date when datepicker is implemented
  const preuseDate = new Date(termData?.contractStartDateOfUse ?? "");
  const isToday = dayjs(defaultContractStartDate).isSame(dayjs(preuseDate), "day");

  const rowExtensionStartDay = new Date(customerExtensionEndDate ?? '');

  const startDate = isExtending
    ? rowExtensionStartDay
    : defaultContractStartDate;

  const rowMembershipPeriodDate =
    termData?.termUnit &&
    calculateIncreasedDate({
      amount: termData?.termValue ?? 0,
      unit: termData?.termUnit ?? '',
      startDate,
    });

  return {
    startDate,
    rowMembershipPeriodDate,
    isToday,
    preuseDate
  };
}
